import { useState } from "react"

import DocViewer, { DocViewerRenderers } from "react-doc-viewer"

import { HtmlDisplay } from "@components/displays/HtmlDisplay"
import { MarkdownDisplay } from "@components/displays/MarkdownDisplay"

import { isHtmlContent } from "@lib/file"
import { isHtml, isImage, isMarkdown, isMsFile, isOfficeFile, isPdf, isPlainText, isTextMarkdown, isVideo } from "@lib/mime"

import { useUserSession } from "@session/UserSession"

interface DocumentDisplayProps {
    documentId: string
    name: string
    type: string
    url: string
}
export function DocumentDisplay({ documentId, name, type, url }: Readonly<DocumentDisplayProps>) {
    const { store } = useUserSession()

    const [text, setText] = useState("")

    if (isHtml(type)) {
        if (!text.length) {
            store.objects.getObjectText(documentId).then((response) => {
                setText(response.text)
            })
        }

        return (
            <div className="w-full h-full overflow-auto p-2">
                <HtmlDisplay content={text} name={name} />
            </div>
        )
    }

    if (isVideo(type)) {
        return (
            <div className="flex w-full h-full items-center justify-center">
                <video src={url} controls style={{ width: "100%" }}>
                    <track kind="captions" src="" label="Captions" />
                </video>
            </div>
        )
    }

    if (isImage(type)) {
        return (
            <div className="flex w-full h-full items-center justify-center">
                <img src={url} alt={name} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
        )
    }

    if (isPdf(type)) {
        return <iframe src={url} height="100%" width="100%" title={`PDF viewer for ${name}`} />
    }

    if (isMsFile(type) || isOfficeFile(type)) {
        const documents = [{ uri: url }]
        return <DocViewer documents={documents} pluginRenderers={DocViewerRenderers} config={{ header: { disableHeader: true, disableFileName: true, retainURLParams: true } }} style={{ width: "100%", height: "100%" }} />
    }

    if (isMarkdown(type) || isTextMarkdown(type) || isPlainText(type)) {
        if (!text.length) {
            store.objects.getObjectText(documentId).then((response) => {
                setText(response.text)
            })
        }

        return isHtmlContent(text) ? (
            <div className="w-full h-full overflow-auto p-2">
                <HtmlDisplay content={text} name={name} />
            </div>
        ) : (
            <div className="w-full h-full overflow-auto p-2">
                <MarkdownDisplay content={text} />
            </div>
        )
    }

    return <span>Sorry for the inconvenience but {type} is not supported.</span>
}
